import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, Router, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
<Helmet>
<meta charSet="utf-8" />
<title>mobiele Bandencentrale</title>

</Helmet>
    <App />

  </React.StrictMode>






);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
